import { render } from "./CopyToClipboard.vue?vue&type=template&id=10a891c9&scoped=true&ts=true"
import script from "./CopyToClipboard.vue?vue&type=script&lang=ts"
export * from "./CopyToClipboard.vue?vue&type=script&lang=ts"

import "./CopyToClipboard.vue?vue&type=style&index=0&id=10a891c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a891c9"]])

export default __exports__